Object.defineProperty(exports, "__esModule", { value: true });
exports.linebreak = exports.edgeNormaliser = exports.pollGlobal = exports.formatPrice = exports.handleize = exports.capitalise = exports.setUrlParameter = exports.getUrlParameter = exports.encodeShopifyId = exports.decodeShopifyId = exports.decodeBase64 = exports.encodeBase64 = exports.isDev = exports.isDomReady = exports.isBrowser = void 0;
exports.isBrowser = typeof window !== "undefined";
exports.isDomReady = exports.isBrowser &&
    (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) &&
    !navigator.userAgent.match(/nux.*oto\sG|x11.*fox\/54|x11.*ome\/39|x11.*ome\/62|oid\s6.*1.*xus\s5.*MRA58N.*ome|JWR66Y.*ome\/62|woobot|speed|ighth|tmetr|eadle/i);
exports.isDev = process.env.GATSBY_ACTIVE_ENV === "development" || process.env.NODE_ENV === "development";
const encodeBase64 = string => {
    try {
        return btoa(string);
    }
    catch (err) {
        return string;
    }
};
exports.encodeBase64 = encodeBase64;
const decodeBase64 = string => {
    try {
        return atob(string);
    }
    catch (err) {
        return string;
    }
};
exports.decodeBase64 = decodeBase64;
const decodeShopifyId = (id, type) => {
    return id ? (0, exports.decodeBase64)(id).split(`${type}/`)[1] : id;
};
exports.decodeShopifyId = decodeShopifyId;
const encodeShopifyId = (id, type) => {
    return id ? (0, exports.encodeBase64)(`gid://shopify/${type}/${id}`) : id;
};
exports.encodeShopifyId = encodeShopifyId;
const getUrlParameter = (name, location = (exports.isBrowser && (window === null || window === void 0 ? void 0 : window.location)) || null) => { var _a; return (_a = new URLSearchParams(location === null || location === void 0 ? void 0 : location.search)) === null || _a === void 0 ? void 0 : _a.get(name); };
exports.getUrlParameter = getUrlParameter;
const setUrlParameter = (name = "", value = "", location = (exports.isBrowser && (window === null || window === void 0 ? void 0 : window.location)) || null) => {
    const url = new URLSearchParams(location === null || location === void 0 ? void 0 : location.search);
    name && value ? url === null || url === void 0 ? void 0 : url.set(name, value) : name && (url === null || url === void 0 ? void 0 : url.delete(name));
    return `${location === null || location === void 0 ? void 0 : location.pathname}${(url === null || url === void 0 ? void 0 : url.toString()) ? `?${url === null || url === void 0 ? void 0 : url.toString()}` : ""}`;
};
exports.setUrlParameter = setUrlParameter;
const capitalise = string => (typeof string === "string" ? `${string.charAt(0).toUpperCase()}${string.slice(1)}` : ``);
exports.capitalise = capitalise;
const handleize = string => string
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, "-")
    .replace(/^-+|-+$/g, "");
exports.handleize = handleize;
const formatPrice = price => { var _a; return ((_a = parseFloat(price === null || price === void 0 ? void 0 : price.replace(/,/g, "."))) === null || _a === void 0 ? void 0 : _a.toFixed(2)) || 0; };
exports.formatPrice = formatPrice;
const pollGlobal = (key, callback) => {
    if (exports.isBrowser) {
        if (window[key]) {
            callback();
        }
        else {
            setTimeout(() => {
                (0, exports.pollGlobal)(key, callback);
            }, 100);
        }
    }
};
exports.pollGlobal = pollGlobal;
const edgeNormaliser = (item) => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.edges) === null || _a === void 0 ? void 0 : _a.map(({ node }) => node)) || item || [item] || []; };
exports.edgeNormaliser = edgeNormaliser;
const linebreak = (content) => content === null || content === void 0 ? void 0 : content.replace(/(?:\r\n|\r|\n)/g, "<br />");
exports.linebreak = linebreak;
//# sourceMappingURL=utils.js.map